import { Component, EventEmitter, Input, Output } from '@angular/core';

import { URLS } from '@hdms/shared/page-frame/data-access';
import { MetaMenuType, MetaNavItem } from '@hdms/shared/page-frame/types';
import { ButtonBaseClassesType, ButtonVariant } from '@hdms/shared/ui-core';

@Component({
  selector: 'shrd-pf-ui-meta-nav',
  templateUrl: './header-meta-nav.component.html'
})
export class HeaderMetaNavComponent {
  @Input() btnVariant: ButtonBaseClassesType = ButtonVariant.TERTIARY_MINOR_BORDERLESS_NEUTRAL_DARK;
  @Input() btnTitle?: string;
  @Input() className?: string;
  @Input() withArrowIcon: boolean;
  @Input() metaNavItems: MetaNavItem[];

  @Output() menuSelected = new EventEmitter<MetaNavItem>();

  readonly cartUrl = URLS.cart;
  readonly metaMenuType = MetaMenuType;

  onMenuSelect(selectedNavItem: MetaNavItem): void {
    this.menuSelected.emit(selectedNavItem);
  }
}
